<template>
    <div class="my-page">
        <!-- 顶部用户信息 -->
        <div class="user-info">
            <div class="user-info-content">
                <div class="user-avatar">
                    <img :src="userInfo.avatar" alt="" />
                </div>
                <div class="user-details">
                    <div class="user-name">{{ userInfo.name}}</div>
                    <div class="user-welcome">欢迎登录！</div>
                </div>
                <div class="edit-btn" @click="goToProfile">
                    <van-icon name="edit" size="20" color="#fff" />
                </div>
            </div>
        </div>

        <div class="content-tabs">
            <div class="menu-grid-card">
                <div
                    class="menu-grid-item"
                    v-for="(item, index) in quickMenus"
                    :key="index"
                    @click="handleQuickMenuClick(item)"
                >
                    <img class="menu-grid-icon" :src="item.icon" :alt="item.title">
                    <div class="menu-grid-title">{{ item.title }}</div>
                </div>
            </div>

            <div class="service-list-card">
                <div
                    class="service-item"
                    v-for="(item, index) in serviceMenus"
                    :key="index"
                    @click="handleServiceMenuClick(item)"
                >
                    <div class="service-left">
                        <img class="service-icon" :src="item.icon" :alt="item.title">
                        <span class="service-title">{{ item.title }}</span>
                    </div>
                    <van-icon name="arrow" size="18" color="#b5b5b5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getLoginInfo } from '@/api/index'
    import { getToken, setUserInfoCache } from '@/utils/auth'

    export default {
        components: {},
        props: {},
        data() {
            return {
                quickMenus: [
                    {
                        title: '考试记录',
                        icon: require('@/assets/image/my-item-01.png'),
                        route: '/my/exam-record'
                    },
                    {
                        title: '我的订单',
                        icon: require('@/assets/image/my-item-02.png'),
                        route: '/my/order-list'
                    },
                    {
                        title: '健康报告',
                        icon: require('@/assets/image/my-item-03.png'),
                        route: '/my/health-report'
                    },
                    {
                        title: '培训证明',
                        icon: require('@/assets/image/my-item-04.png'),
                        route: '/my/certificate-list'
                    }
                ],
                serviceMenus: [
                    { title: '个人剂量', icon: require('@/assets/image/my-icon-01.png'), route: '/my/dosage-report' },
                    { title: '个人信息', icon: require('@/assets/image/my-icon-02.png'), route: '/profile' },
                    { title: '直播培训', icon: require('@/assets/image/my-icon-03.png'), route: '/course' }
                ],
                /** 本页专用：由 getLoginInfo 接口填充，不依赖 Vuex */
                userInfo: {
                    id: '',
                    name: '',
                    account: '',
                    avatar: '',
                    idCard: '',
                    phone: '',
                    medicalName: '',
                    workingState: '',
                    work: ''
                }
            };
        },
        created() {
            this.fetchUserInfo()
        },
        methods: {
            /** 当前页调接口取用户信息，并写回本页 data；顺带同步 store / localStorage 供其它页使用 */
            fetchUserInfo() {
                if (!getToken()) {
                    return
                }
                getLoginInfo()
                    .then(res => {
                        if (res.data) {
                            const userInfo = {
                                id: res.data.id || '',
                                name: res.data.name || '',
                                account: res.data.account || '',
                                avatar: res.data.avatar || '',
                                idCard: res.data.idCard || '',
                                phone: res.data.phone || '',
                                medicalName: res.data.medicalName || res.data.hospital || '',
                                workingState: res.data.workingState || res.data.type || '',
                                work: res.data.work || ''
                            }
                            this.userInfo = userInfo
                            setUserInfoCache(userInfo)
                            this.$store.commit('setUserInfo', userInfo)
                        }
                    })
                    .catch(err => {
                        console.error('获取用户信息失败:', err)
                    })
            },
            goToProfile() {
                this.$router.push('/profile');
            },
            handleQuickMenuClick(item) {
                if (item.route) {
                    this.$router.push(item.route);
                }
            },
            handleServiceMenuClick(item) {
                if (item.route) {
                    this.$router.push(item.route);
                }
            }
        },
    };
</script>

<style scoped lang='scss'>
.my-page {
    min-height: 100vh;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
}

.user-info {
    position: relative;
    box-sizing: border-box;
    padding: 25px 15px;
    width: 100%;
    height: 211px;
    background: url('~@/assets/image/my-top-bg.png') no-repeat center center;
    background-size: 100% 100%;
}
.user-info-content{
    display: flex;
    align-items: center;
    height: 45px;
    .user-avatar {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid rgba(255, 255, 255, 0.5);
        flex-shrink: 0;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .user-details {
        margin-left: 7px;
        flex: 1;
        .user-name {
            font-size: 15px;
            color: #fff;
            margin-bottom: 4px;
        }
        .user-welcome {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.6);
            cursor: pointer;
            
            &:active {
                opacity: 0.8;
            }
        }
    }
    .edit-btn {
        width: 40px;
        height: 40px;
        background: #0A578A;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:active {
            background: rgba(255, 255, 255, 0.3);
        }
    }

}

.content-tabs {
    margin-top: -100px;
    flex: 1;
    min-height: auto;
    box-sizing: border-box;
    position: relative;
    border-radius: 20px 20px 0 0;
    padding: 10px 14px 24px;
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    z-index: 2;
    overflow-y: auto;
}

.menu-grid-card {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: center;
    background: #fff;
    border-radius: 14px;
    padding: 16px 8px 12px;
}

.menu-grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 7px;
    cursor: pointer;

    &:active {
        opacity: 0.75;
    }
}

.menu-grid-icon {
    width: 56px;
    height: 56px;
    object-fit: contain;
}

.menu-grid-title {
    font-size: 13px;
    color: #333;
    line-height: 1.2;
}

.service-list-card {
    background: #fff;
    border-radius: 14px;
    margin-top: 14px;
    padding: 0 12px;
}

.service-item {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f1f3;
    cursor: pointer;

    &:last-child {
        border-bottom: none;
    }

    &:active {
        opacity: 0.75;
    }
}

.service-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.service-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.service-title {
    font-size: 15px;
    color: #333;
}
</style>